import React, { Component } from 'react'; 
import {Accordion, Card, InputGroup, FormControl, Button} from 'react-bootstrap';
import AdditionalFields from './AdditionalFields';

import _ from 'lodash';

class FormElements extends Component {
  constructor(props){
    super(props)
    this.state={
      onActiveKey:0,
      payload:props.payload
    }
  }
  componentDidMount(){  
    this.props.function.action()      
  }
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(nextProps.function.showModalLogin, this.props.function.showModalLogin) && nextProps.function.showModalLogin === false){     
      this.props.function.action()      
    }
    if(!_.isEqual(this.props.payload, nextProps.payload)){
      this.setState({payload:nextProps.payload})
    }
  } 
  addValues = (prop) => {
    // if(this.props.payload[prop].length <= 20){
      this.setState({['show'+prop]:true})
    //}
    this.setState({onActiveKey:prop})
  }
  handleChangeSub = (e) => { 
    this.setState({[e.target.id]:e.target.value});
    if(!_.isEmpty(e.target.value)){
      this.setState({['inputerror'+e.target.id]: false})
    }
  }
  handleaddData =(prop) => {     
    if(!_.isEmpty(this.state[prop])){      
      let obj = {'label':this.state[prop], 'status':'ACTIVE'}
      this.props.function.addValues(prop, obj);
      this.setState({['show'+prop]:false, [prop]:''})
    } else {
      this.setState({['inputerror'+prop]: true})
    }
  }
  handleEditData = (prop, obj, i) => {
    this.setState({['edit'+prop+i]:true})
  }
  editFalse = (e, i, prop, obj) => {   
    if(!_.isEmpty(this.state['label'+prop+i]) || (!_.isEmpty(e.target.value))){
     this.setState({['edit'+prop+i]:false})   
     this.props.function.editValues(prop, obj, e.target.value, i);
    } 
  }
  
  handleChange = (e, i, obj, prop) => {
    this.setState({['label'+prop+i]:e.target.value})
  }
  handleActive = (prop, obj) => {
    this.props.function.activeValues(prop, obj); 
  }
  handleInActiveDelete = (prop, obj) => {
     this.props.function.deleteValues(prop, obj); 
  }
  editAdditionalFields = (i) => {
    this.setState({['additionalEdit'+i] : true})
  }
  editAdditionalFieldsClose = (i) => {
    this.setState({['additionalEdit'+i] : false})
  }
  addParameterstoDropDown = (props, values) => {
    props.additionalValues.push(...values)
    this.props.function.AdditionalFieldEdit('Addtional Fields', props);
    
  }
  duplicateItems = (obj) =>{
    const{payload} = this.state;
    let prop = 'Addtional Fields'
    let x = _.cloneDeep(payload[prop])
    let idVal = _.findLastIndex(x) 
    idVal= ++idVal;
    let nextObj = _.cloneDeep(obj)
    let key = Object.keys(nextObj)
    for (key in nextObj) {
      if (nextObj.hasOwnProperty(key)) {
          nextObj[key] = [];
          nextObj['status'] = 'ACTIVE'
      }
    }    
    nextObj.id = idVal
    nextObj.label = obj.label
    this.props.function.addValues("Addtional Fields", nextObj);
  }
  handleSave = () => {
      this.props.function.TokenValidation()
      this.props.function.formElementsSaveAction(this.state.payload)
  }
  onActiveKey = (i) =>{ 
    if(_.isEqual(this.state.onActiveKey, i)){
      this.setState({onActiveKey:0})
      this.setState({['show'+i]:false})
    } else{
      this.setState({onActiveKey:i})
    }
  }
  validateSave = () =>{
    const identifiers = Object.keys(this.state)
    let keys = [];
    _.map(identifiers, (key) =>{      
      keys.push(this.state[key])
    })
    let obj = _.includes(keys, true)
    
    if(!obj){
      return true
    }
  }
  
  render(){    
    const{payload} = this.state;
    return(
      <Accordion activeKey={this.state.onActiveKey}>
      {_.map(payload , (object, index) =>{
        return (          
          <Card>
          <Accordion.Toggle  as={Card.Header} onClick={()=>this.onActiveKey(index)} eventKey={index} >
            {index }            
          </Accordion.Toggle>
          {(index === 'Addtional Fields') ? <i class="fas fa-chevron-circle-down accord PositionAbsolute" style={{color:"green"}}></i> :
            <i class="fas fa-plus-circle accord PositionAbsolute" onClick={()=>this.addValues(index)} /> }
          <Accordion.Collapse eventKey={index}>          
          <Card.Body>
          { this.state['show'+index] ? <InputGroup style={{'marginBottom':'1%'}}>
            <FormControl id={index} value={this.state[index]} onChange={(e)=>this.handleChangeSub(e)}
              className={this.state['inputerror'+index] ? 'input-fail': ""} autoFocus />
            <InputGroup.Append>
            <InputGroup.Text onClick={()=>this.handleaddData(index)} className="cursorPointer">Add</InputGroup.Text>
            </InputGroup.Append>
            </InputGroup>  
            : null }  
            {
            _.map(object, (obj, i)=> {
             let returnObj;
             if(index === 'Addtional Fields') {
              returnObj =(<div>
                  {(obj.status === 'INACTIVE') ? 
                  <i class="fas fa-check rightelem " onClick={()=> this.handleActive(index, obj)}/>  :
                  <i class="fas fa-times-circle rightelem" onClick={()=> this.handleInActiveDelete(index, obj)}/> }
                  <li className={obj.status === 'INACTIVE' ? 'disabled edit' :'edit'}>{obj.label}--{obj.labelObj}
                  <i class="fas fa-pen rightelem" onClick={()=>this.editAdditionalFields(i)} />
                  { this.state['additionalEdit'+i] ?
                    <AdditionalFields addValues={this.addParameterstoDropDown}
                    closeModal={()=>this.editAdditionalFieldsClose(i)} object={object} obj={obj} index={i}/>
                    : null
                  }
                  <i class="fas fa-plus-circle accord" onClick={()=>this.duplicateItems(obj)} />
                  </li>                  
                </div>)

             } else {
              returnObj= (<div>
              {(obj.status === 'INACTIVE') ? 
              <i class="fas fa-check rightelem" onClick={()=> this.handleActive(index, obj)}/>  :
              <i class="fas fa-times-circle rightelem " onClick={()=> this.handleInActiveDelete(index, obj)}/> }
              <li className={obj.status === 'INACTIVE' ? 'disabled edit' :'edit'}>{this.state['edit'+index+i] === true ? 
              <FormControl type='text' className={'input-fail'}  
              onBlur={(e)=>this.editFalse(e,i,index, obj)} value={(typeof this.state['label'+index+i] !== "undefined") ?
              this.state['label'+index+i] : obj.label} onChange={(e)=>this.handleChange(e, i, obj, index)} autofocus/> : 
              this.state['label'+index+i] ? this.state['label'+index+i] : obj.label}
              <i class="fas fa-pen rightelem " onClick={()=> this.handleEditData(index, obj, i)}/> </li>
              
              </div>) }
            return returnObj
            }) } 
          </Card.Body>
          </Accordion.Collapse>
          </Card>
        )
      }) }
      <br/>
       <Button className='buttonwidth alignRight' size='md' onClick={this.handleSave} disabled={!this.validateSave()}>SAVE</Button>
       </Accordion>
    );
  }
}





export default FormElements;